module.exports = __webpack_public_path__ + "img/step4a-mobile-en.fb579e79.webp";